<template>
    <div class="service-form-box">
        <van-form @submit="onSubmit" label-width="9em" ref="formService">
            <van-cell-group class="form-group">
                <van-field
                    key="customerType"
                    name="customer_type"
                    :value="customerType | customerTypeFilter"
                    readonly
                    label="知识合伙人类型"
                />
            </van-cell-group>
            <van-cell-group v-if="customerType != 2" class="form-group">
                <h3 class="cell_title">营业信息</h3>
                <van-field
                    class="required-label"
                    name="businessLicense"
                    label="营业执照"
                    :value="formObj.businessLicense[0]"
                    :rules="[{ required: true, message: '请上传营业执照' }]"
                >
                    <template #input>
                        <CellUpload
                            type="BUSINESS_LICENSE"
                            v-model="formObj.businessLicense"
                            @change="(content) => uploadChange('BUSINESS_LICENSE', content)"
                        />
                    </template>
                </van-field>
                <van-field
                    class="required-label"
                    name="enterpriseName"
                    v-model="formObj.enterpriseName"
                    label="营业名称"
                    placeholder="请输入"
                    :rules="[
                        { required: true, message: '请输入营业名称' },
                        { pattern: /^.{0,40}$/, message: '长度限制40个字符' },
                    ]"
                />
                <van-field
                    class="required-label"
                    name="socialUnifiedCode"
                    v-model="formObj.socialUnifiedCode"
                    label="社会统一代码"
                    placeholder="请输入"
                    :rules="[
                        { required: true, message: '请输入社会统一代码' },
                        { pattern: /^.{0,18}$/, message: '长度限制18个字符' },
                    ]"
                />
                <van-field
                    class="required-label"
                    name="districtCode"
                    label="经营地址"
                    placeholder="请输入"
                    :value="formObj.districtCode"
                    :rules="[{ required: true, message: '请选择经营地址' }]"
                >
                    <template #input>
                        <van-cell
                            class="date_cell"
                            is-link
                            :value="areaText"
                            @click="openAreaPopup"
                        />
                    </template>
                </van-field>
                <van-popup v-model="showArea" position="bottom">
                    <van-area
                        :loading="areaLoding"
                        :area-list="areaList"
                        :value="formObj.districtCode"
                        :columns-placeholder="['请选择', '请选择', '请选择']"
                        @change="areaChange"
                        @confirm="areaConfirm"
                        @cancel="showArea = false"
                    />
                </van-popup>
                <van-field
                    name="detailAddress"
                    v-model="formObj.detailAddress"
                    label="补充地址"
                    placeholder="请输入"
                    :rules="[
                        {
                            validator: detailAddressValidator,
                            message: '长度限制5-20个字符',
                        },
                    ]"
                />
            </van-cell-group>
            <van-cell-group class="form-group">
                <h3 class="cell_title">
                    {{ customerType != 2 ? "法人信息" : "实名信息" }}
                </h3>
                <van-field
                    class="required-label"
                    name="lpidCardFront"
                    label="身份证头像面"
                    :value="formObj.lpidCardFront[0]"
                    :rules="[{ required: true, message: '请上传身份证' }]"
                >
                    <template #input>
                        <CellUpload
                            type="ID_CARD"
                            v-model="formObj.lpidCardFront"
                            @change="(content) => uploadChange('ID_CARD', content)"
                        />
                    </template>
                </van-field>
                <van-field
                    class="required-label"
                    name="lpidCardBack"
                    label="身份证国徽面"
                    :value="formObj.lpidCardBack[0]"
                    :rules="[{ required: true, message: '请上传身份证' }]"
                >
                    <template #input>
                        <CellUpload
                            type="ID_CARD"
                            v-model="formObj.lpidCardBack"
                            @change="(content) => uploadChange('ID_CARD_BACK', content)"
                        />
                    </template>
                </van-field>
                <van-field
                    class="required-label"
                    name="lpName"
                    v-model="formObj.lpName"
                    label="法人姓名"
                    placeholder="请输入"
                    :rules="[
                        { required: true, message: '请输入法人姓名' },
                        { pattern: /^.{0,10}$/, message: '长度限制10个字符' },
                    ]"
                />
                <van-field
                    class="required-label"
                    name="lpidCardNum"
                    v-model="formObj.lpidCardNum"
                    label="身份证号"
                    placeholder="请输入"
                    :rules="[
                        { required: true, message: '请输入身份证号' },
                        {
                            pattern:
                                /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/i,
                            message: '身份证号格式错误',
                            trigger: 'onBlur',
                        },
                    ]"
                />
                <van-field
                    class="required-label"
                    name="validityPeriod"
                    label="身份证有效期"
                    :value="formObj.validityPeriod"
                    :rules="[{ required: true, message: '请选择身份证有效期' }]"
                >
                    <template #input>
                        <van-cell
                            class="date_cell"
                            is-link
                            @click="beginDatePickerShow = true"
                            :value="cardDate ? cardDate : '请选择'"
                        />
                    </template>
                </van-field>
                <van-popup v-model="beginDatePickerShow" position="bottom" round>
                    <van-datetime-picker
                        type="date"
                        title="开始时间"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @confirm="beginDateConfirm"
                        @cancel="beginDatePickerShow = false"
                    />
                </van-popup>
                <van-popup v-model="endDatePickerShow" position="bottom" round>
                    <van-datetime-picker
                        type="date"
                        title="结束时间"
                        :min-date="minDate1"
                        :max-date="maxDate1"
                        :readonly="is_valid"
                        @confirm="endDateConfirm"
                        @cancel="endDatePickerShow = false"
                    />
                    <van-checkbox
                        class="date_popup_check"
                        v-model="is_valid"
                        shape="square"
                        icon-size="14px"
                    >
                        长期有效
                    </van-checkbox>
                </van-popup>
            </van-cell-group>
            <van-cell-group v-if="customerType != 2" class="form-group">
                <h3 class="cell_title">联系人信息</h3>
                <van-field
                    class="required-label"
                    name="responsibleName"
                    v-model="formObj.responsibleName"
                    label="姓名"
                    placeholder="请输入"
                    :rules="[
                        { required: true, message: '请输入姓名' },
                        { pattern: /^.{0,10}$/, message: '长度限制10个字符' },
                    ]"
                />
                <van-field
                    class="required-label"
                    name="responsiblePhone"
                    v-model="formObj.responsiblePhone"
                    label="手机号"
                    placeholder="请输入"
                    :rules="[
                        { required: true, message: '请输入手机号' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '手机号格式错误',
                            trigger: 'onBlur',
                        },
                    ]"
                />
                <van-field
                    class="required-label"
                    name="validateCode"
                    label="验证码"
                    v-model="formObj.validateCode"
                    placeholder="请输入"
                    :rules="[{ required: true, message: '请输入验证码' }]"
                >
                    <template #button>
                        <van-button
                            native-type="button"
                            class="validate-btn"
                            color="#4A79F1"
                            plain
                            :disabled="codeFlag"
                            @click="getValidate"
                            >{{ codeFlag ? codeNum + "秒后重新获取" : "获取验证码" }}</van-button
                        >
                    </template>
                </van-field>
            </van-cell-group>
            <div class="agreement-box">
                <van-checkbox v-model="hasAgree">已阅读并同意</van-checkbox>
                <span class="agreement-text" @click="$router.push('/partner/partner-agreement')"
                    >《中文知识网知识合伙人入驻协议》
                </span>
            </div>
            <div class="btn-box">
                <van-button
                    class="form_btn"
                    round
                    block
                    type="info"
                    native-type="submit"
                    :loading="btnLoding"
                >
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import { Toast } from "vant";
import CellUpload from "../components/CellUpload";
export default {
    name: "PartnerServiceForm",
    components: {
        CellUpload,
    },
    data() {
        return {
            customerType: "",
            btnLoding: false,
            showArea: false,
            areaLoding: false,
            formObj: {
                businessLicense: [],
                enterpriseName: "",
                socialUnifiedCode: "",
                provinceCode: "",
                provinceName: "",
                cityCode: "",
                cityName: "",
                districtCode: "",
                districtName: "",
                detailAddress: "",
                lpidCardFront: [],
                lpidCardBack: [],
                lpName: "",
                lpidCardNum: "",
                validityPeriod: "",
                validityPeriodBegin: "",
                responsibleName: "",
                responsiblePhone: "",
                validateCode: "",
                longTerm: false,
            },
            areaText: "请选择",
            areaList: {
                province_list: {},
                city_list: {},
                county_list: {},
            },
            cardDate: "",
            beginDatePickerShow: false,
            endDatePickerShow: false,
            minDate: new Date(1970, 1, 1),
            minDate1: new Date(1970, 1, 1),
            maxDate: new Date(new Date().getFullYear() + 30, 11, 31),
            maxDate1: new Date(new Date().getFullYear() + 30, 11, 31),
            is_valid: false,
            codeFlag: false,
            codeNum: 59,
            hasAgree: false,
        };
    },
    created() {
        this.customerType = this.$route.query.customerType;
        if (this.$route.query.isFail) {
            this.getStatus();
        }
    },
    filters: {
        customerTypeFilter(type) {
            switch (type) {
                case "2":
                    return "学者";
                case "4":
                    return "期刊";
                case "5":
                    return "机构";
            }
        },
    },
    watch: {
        "formObj.districtName": {
            async handler(newV, oldV) {
                console.log(newV, "newV");
                this.areaText = `${this.formObj.provinceName}-${this.formObj.cityName}-${newV}`;
            },
            deep: true,
        },
        "formObj.validityPeriod": {
            async handler(newV, oldV) {
                console.log(newV, "newV");
                this.formObj.longTerm = newV == "9999-12-31";
                let validityPeriod = newV == "9999-12-31" ? "长期" : newV.replace(/-/g, ".");
                let validityPeriodBegin = this.formObj.validityPeriodBegin.replace(/-/g, ".");
                this.cardDate = `${validityPeriodBegin}-${validityPeriod}`;
            },
            deep: true,
        },
    },
    methods: {
        async getStatus() {
            const res = await this.$apis.userServe.getPartnerDetail();
            if (res.resultCode === "200") {
                if (res.data.review) {
                    for (const key in this.formObj) {
                        if (
                            key === "businessLicense" ||
                            key === "lpidCardFront" ||
                            key === "lpidCardBack"
                        ) {
                            this.formObj[key].push(res.data.review[key]);
                        } else {
                            this.formObj[key] = res.data.review[key];
                        }
                    }
                }
            }
        },
        detailAddressValidator(value) {
            if (value) {
                const regex = /^.{5,20}$/;
                return regex.test(value);
            } else {
                return true;
            }
        },
        getValidate() {
            this.$refs.formService
                .validate("responsiblePhone")
                .then(async () => {
                    const res = await this.$apis.loginServe.getCode({
                        phone: this.formObj.responsiblePhone,
                        adapter: "partner_apply",
                    });
                    if (res.resultCode == "200") {
                        Toast("获取成功");
                        this.validateTime();
                    } else {
                        Toast(res.resultDesc);
                    }
                })
                .catch((err) => {
                    Toast(err.message);
                });
        },
        // 获取验证码时间
        validateTime() {
            this.codeFlag = true;
            let timer = setInterval(() => {
                if (this.codeNum <= 0) {
                    clearInterval(timer);
                    this.codeFlag = false;
                    this.codeNum = 59;
                } else {
                    this.codeNum = --this.codeNum;
                }
            }, 1000);
        },
        endDateConfirm(query) {
            this.formObj.validityPeriod = this.is_valid
                ? "9999-12-31"
                : this.$global.transferDay(query);
            this.endDatePickerShow = false;
        },
        beginDateConfirm(query) {
            this.formObj.validityPeriodBegin = this.$global.transferDay(query);
            this.minDate1 = new Date(this.formObj.validityPeriodBegin);
            this.maxDate1 = new Date(new Date(query).getFullYear() + 30, 11, 31);
            this.beginDatePickerShow = false;
            this.endDatePickerShow = true;
        },
        openAreaPopup() {
            if (JSON.stringify(this.areaList.province_list) == "{}") this.getAreaArr("", 0);
            this.showArea = true;
        },
        areaConfirm(value) {
            if (value.every((item) => item && item.code !== "")) {
                this.formObj.provinceCode = value[0].code;
                this.formObj.provinceName = value[0].name;
                this.formObj.cityCode = value[1].code;
                this.formObj.cityName = value[1].name;
                this.formObj.districtCode = value[2].code;
                this.formObj.districtName = value[2].name;
                this.showArea = false;
            }
        },
        areaChange(_, pickValue, index) {
            this.getAreaArr(pickValue[index].code, index + 1);
        },
        async getAreaArr(params, type) {
            if (type === 3) return;
            let areaObj = {};
            this.areaLoding = true;
            const res = await this.$apis.zzsignServe.getArea({ code: params });
            if (res.resultCode === "200") {
                res.data.forEach((item) => {
                    areaObj[item.code] = item.name;
                });
                switch (type) {
                    case 0:
                        this.areaList.province_list = areaObj;
                        this.areaList.city_list = {};
                        this.areaList.county_list = {};
                        break;
                    case 1:
                        this.areaList.city_list = areaObj;
                        this.areaList.county_list = {};
                        break;
                    case 2:
                        this.areaList.county_list = areaObj;
                        break;
                }
                this.areaLoding = false;
            }
        },
        uploadChange(type, content) {
            if (content.obj) {
                if (type === "BUSINESS_LICENSE") {
                    this.formObj.enterpriseName = content.obj.companyName;
                    this.formObj.socialUnifiedCode = content.obj.creditCode;
                    this.formObj.detailAddress = content.obj.detail;
                    let provinceObj = content.province.filter((item) => item.status === 1)[0];
                    let cityObj = content.city.filter((item) => item.status === 1)[0];
                    let districtObj = content.area.filter((item) => item.status === 1)[0];
                    this.formObj.provinceCode = provinceObj.code;
                    this.formObj.provinceName = provinceObj.name;
                    this.formObj.cityCode = cityObj.code;
                    this.formObj.cityName = cityObj.name;
                    this.formObj.districtCode = districtObj.code;
                    this.formObj.districtName = districtObj.name;
                } else if (type === "ID_CARD") {
                    console.log(content, "conte");
                    this.formObj.lpName = content.obj.name;
                    this.formObj.lpidCardNum = content.obj.idNumber;
                } else {
                    console.log(content, "conte");
                    let validPeriodArr = content.obj.validPeriod.split("-");
                    let validityPeriodBegin = validPeriodArr[0];
                    let validityPeriod =
                        validPeriodArr[1] === "长期" ? "9999-12-31" : validPeriodArr[1];
                    this.formObj.validityPeriodBegin = this.$global.transferDay(
                        new Date(validityPeriodBegin)
                    );
                    this.formObj.validityPeriod = this.$global.transferDay(
                        new Date(validityPeriod)
                    );
                }
            }
        },
        async onSubmit() {
            if (this.hasAgree) {
                console.log(this.formObj, "formObj");
                let paramsObj = {};
                if (this.customerType == 2) {
                    paramsObj = {
                        lpidCardFront: "",
                        lpidCardBack: "",
                        lpName: "",
                        lpidCardNum: "",
                        validityPeriod: "",
                        validityPeriodBegin: "",
                    };
                    for (const key in paramsObj) {
                        if (key === "lpidCardFront" || key === "lpidCardBack") {
                            paramsObj[key] = this.formObj[key][0];
                        } else {
                            paramsObj[key] = this.formObj[key];
                        }
                    }
                } else {
                    for (const key in this.formObj) {
                        if (
                            key === "businessLicense" ||
                            key === "lpidCardFront" ||
                            key === "lpidCardBack"
                        ) {
                            paramsObj[key] = this.formObj[key][0];
                        } else {
                            paramsObj[key] = this.formObj[key];
                        }
                    }
                }
                console.log(paramsObj, "paramsObj");
                const res = await this.$apis.zzsignServe.partnerApply(paramsObj);
                if (res.resultCode === "200") {
                    this.$router.replace({
                        path: "/partner/partner-result",
                        query: { customerType: this.customerType },
                    });
                } else {
                    Toast.fail(res.resultDesc);
                }
            } else {
                Toast("请阅读并同意《中文知识知识合伙人入驻协议》");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.service-form-box {
    padding: 12px;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 67px) !important;
    padding-bottom: calc(env(safe-area-inset-bottom) + 67px) !important;
    min-height: calc(100vh - (constant(safe-area-inset-top) + 44px));
    min-height: calc(100vh - (env(safe-area-inset-top) + 44px));
    background-color: #f5f5f5;
    &::v-deep .van-cell-group {
        margin-bottom: 12px;
        padding: 0 12px;
        border-radius: 8px;
        overflow: hidden;

        .van-cell {
            padding: 17px 0;
            border-bottom: 1px solid #eee;

            &:last-child {
                border: none;
            }

            .van-field__label {
                //   width: 100px;
            }

            .van-cell__title {
                color: #333333;
            }

            .van-field__control {
                text-align: right;
            }

            &::after {
                border: none;
            }
        }

        .date_cell {
            padding: 0;
            border: none;

            .van-cell__value {
                text-align: right;
            }
        }
        .validate-btn {
            padding: 7px 5px;
            height: unset;
            border-radius: 4px;
            border: 1px solid #4a79f1;
            font-size: 13px;
        }

        .van-field--error {
            position: relative;
            padding-bottom: 41px;

            .van-cell__title,
            .van-cell__value {
                position: unset;
            }

            .van-field__error-message {
                position: absolute;
                left: 0;
                // text-align: right;
            }

            .van-field__control {
                color: #333;

                &::placeholder {
                    color: #333;
                }
            }
        }

        .required-label {
            .van-field__label {
                span {
                    &::after {
                        content: "*";
                        color: red;
                    }
                }
            }
        }
    }
    .cell_title {
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        margin: 13px 0 3px;
    }
}

.date_popup_check {
    margin: 22px 0;
    justify-content: center;
}
.agreement-box {
    display: flex;
    &::v-deep .van-checkbox__label {
        font-size: 13px;
        color: #999999;
    }
    .agreement-text {
        font-size: 13px;
        color: #4a79f1;
    }
}
.btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    padding-top: 6px;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 6px) !important;
    padding-bottom: calc(env(safe-area-inset-bottom) + 6px) !important;
    width: 100vw;
    background-color: #fff;
    .form_btn {
        margin: 0 auto;
        width: 345px;
        height: 44px;
        background: #4a79f1;
        border-radius: 22px;
    }
}
</style>
